import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'tlc-churn-flow-tellent-impact-logo',
  templateUrl: './churn-flow-tellent-impact-logo.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: true,
})
export class ChurnFlowTellentImpactLogoComponent {}
